import { render, staticRenderFns } from "./TheFacilitiesLocksList.vue?vue&type=template&id=6c5d6559&"
import script from "./TheFacilitiesLocksList.vue?vue&type=script&lang=js&"
export * from "./TheFacilitiesLocksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports